/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-29 15:31:04
 */

import * as Vue from "vue-tsx-support";
import {Component, Prop} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import Modal from "src/types/iview/Modal";
import Button from "src/types/iview/Button";
import Input from "src/types/iview/Input";
import {Toast} from "src/util/toast";
import {modalFactory} from "src/util/vueExtend";
import UserConfigApi from 'src/pages/systemConfig/userConfig/api/userConfigApi';

export namespace UpdatePasswordVOI {
	export interface PropsI {
		saveSuccess? (): void

		cancel? (): void
	}

	export interface FormDataI {
		oldPassword: string
		newPassword:string,
		confirmPassword:string,
	}
}

@Component
class UpdatePasswordModal extends Vue.Component<UpdatePasswordVOI.PropsI> {
	@Prop({
		type: Function
	})
	cancel!: () => void

	@Prop({
		type: Function
	})
	saveSuccess!: () => void

	visible: boolean = false

	loading: boolean = false

	formData: UpdatePasswordVOI.FormDataI = {
		oldPassword: '',
		newPassword:'',
		confirmPassword:'',
	}
	rules: any = {
	}

	close () {
		this.cancel && this.cancel()
		this.closeModal()
	}

	closeModal() {
		this.visible = false
		this.$emit('close', false)
	}

	async save () {
		if(!await this.$validate('formValidate')) {
			return
		}
		this.loading = true
		let {code} = await UserConfigApi.updatePassword(this.formData.oldPassword, this.formData.newPassword)
		this.loading = false
		if (code === 0) {
			Toast.success('修改密码成功！')
			this.saveSuccess()
			this.closeModal()
		}
    }
    mounted() {
        let t = this
        this.rules.confirmPassword= [
            {
                validator: (rule, value, callback) => {
                    if (t.formData.confirmPassword !== t.formData.newPassword) {
                        callback(new Error('两次输入密码不同'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur',
            },
        ]
    }

	render (h) {
		return (
			<Modal
				title="修改密码"
				width="500"
				v-model={this.visible}
				mask-closable={false}
				on-on-cancel={this.close}
			>
				<i-form style="width:80%" ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                        <form-item label="原密码" prop="oldPassword" required >
                            <Input v-model={this.formData.oldPassword} placeholder="请输入" type="password" />
                        </form-item>
                        <form-item label="新密码" prop="newPassword" required >
                            <Input v-model={this.formData.newPassword} placeholder="请输入" type="password" />
                        </form-item>
                        <form-item label="确认密码" prop="confirmPassword" required >
                            <Input v-model={this.formData.confirmPassword} placeholder="请输入" type="password" />
                        </form-item>
                </i-form>
				<div slot="footer">
					<Button type="primary" ghost on-click={this.close}>取消</Button>
					<Button type="primary" on-click={this.save} loading={this.loading}>保存</Button>
				</div>
			</Modal>
		);
	}
}

export default function alertUpdatePasswordModal (): Promise<boolean> {
		return new Promise((resolve, reject) => {
			modalFactory<UpdatePasswordVOI.PropsI>(UpdatePasswordModal)({
				saveSuccess () {
					resolve(true)
				},
				cancel () {
					resolve(false)
				}
			})
		})
	}
